import React from "react";
import { useSelector } from "react-redux";
import { fmt } from "../uiUtils";

/**
 * The persistent mobile/tablet checkout bar (shown by register.css below 900px).
 *
 * WHY IT EXISTS: below 900px the cart cannot stay docked without starving the catalogue, so it
 * becomes a bottom sheet. But a register whose total is hidden behind a tap is not a register — the
 * cashier is reading that number out loud to a customer. This bar is the compromise: the two facts
 * that must never be more than a glance away (what is owed, and how to take payment) stay pinned to
 * the bottom of the screen inside the thumb arc, and the full cart is one tap up.
 *
 * The whole left region is the cart trigger, not a small chevron — on a phone a corner-sized target
 * is a miss waiting to happen.
 */
export default function CheckoutBar({ onOpenCart, onPay }) {
  const { lines, totals } = useSelector((st) => st.webRegisterCart);
  const itemCount = lines.reduce((s, l) => s + (Number(l.orderCount) || 0), 0);
  const empty = lines.length === 0;

  return (
    <div className="qv-checkout">
      <button
        type="button"
        className="qv-checkout-open"
        onClick={onOpenCart}
        aria-label={`Open cart, ${itemCount} item${itemCount === 1 ? "" : "s"}, total ${fmt(totals.display ? totals.display.payAmount : totals.grandTotal)}`}
      >
        <span className="qv-checkout-count">▲ {itemCount} item{itemCount === 1 ? "" : "s"}</span>
        <span className="qv-checkout-total qv-num">{fmt(totals.display ? totals.display.payAmount : totals.grandTotal)}</span>
      </button>

      {/* Spacer that doubles as extra tap area for opening the cart. */}
      <button type="button" className="qv-checkout-grab" onClick={onOpenCart} aria-hidden="true" tabIndex={-1} />

      <button
        className="qv-btn qv-btn--primary qv-pay"
        disabled={empty}
        onClick={() => (empty ? null : onPay())}
      >
        Pay
      </button>
    </div>
  );
}
